type TBinIconProps = {
	stroke?: string;
};

export const BinIcon = ({
	stroke = "#718096",
}: TBinIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			aria-hidden="true"
			focusable="false"
		>
			<path
				d="M17.5 4.98333C14.725 4.70833 11.9333 4.56667 9.15 4.56667C7.5 4.56667 5.85 4.65 4.2 4.81667L2.5 4.98333"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.08203 4.14166L7.26536 3.05C7.3987 2.25833 7.4987 1.66666 8.90703 1.66666H11.0904C12.4987 1.66666 12.607 2.29166 12.732 3.05833L12.9154 4.14166"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.7096 7.61667L15.168 16.0083C15.0763 17.3167 15.0013 18.3333 12.6763 18.3333H7.3263C5.0013 18.3333 4.9263 17.3167 4.83464 16.0083L4.29297 7.61667"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.60938 13.75H11.3844"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.91797 10.4167H12.0846"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
